var version = require("./version")

module.exports = VirtualText

function VirtualText(text) {
    this.text = String(text)
}

VirtualText.prototype.version = version
VirtualText.prototype.type = "VirtualText"



//////////////////
// WEBPACK FOOTER
// ./~/virtual-dom/vnode/vtext.js
// module id = 36
// module chunks = 0